// Custom event system for cross-component communication

// Dragon Ball collection events
export const DRAGON_BALL_COLLECTED = 'dragonBallCollected';
export const DRAGON_BALL_WISH_MADE = 'dragonBallWishMade';
export const RADAR_OPEN = 'dragonRadarOpen';
export const RADAR_PEEK = 'dragonRadarPeek';
export const RADAR_SUMMON = 'dragonRadarSummon';

// Friend request events
export const FRIEND_REQUEST_SENT = 'friendRequestSent';
export const FRIEND_REQUEST_RECEIVED = 'friendRequestReceived';
export const FRIEND_REQUEST_ACCEPTED = 'friendRequestAccepted';
export const FRIEND_REQUEST_REJECTED = 'friendRequestRejected';
export const FRIEND_REMOVED = 'friendRemoved';

// Emit a custom event
export const emitEvent = (eventName, data = {}) => {
  const event = new CustomEvent(eventName, { detail: data });
  window.dispatchEvent(event);
};

// Subscribe to a custom event
export const subscribeToEvent = (eventName, callback) => {
  const handler = (e) => callback(e.detail);
  window.addEventListener(eventName, handler);
  return () => window.removeEventListener(eventName, handler);
};
